import { POST_DATA_STORE, SHOW_STORE_MODAL } from './actionTypes';

export const postDataStore = (dataPost) => ({
  type: POST_DATA_STORE,
  dataPost,
});

export const showModalStore = (data) => ({
  type: SHOW_STORE_MODAL,
  data,
});
